import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stepNumber: 0,
  isEdit: false,
};

export const pageSlice = createSlice({
  name: "pageSlice",
  initialState,
  reducers: {
    setStepNumber: (state, action) => {
      state.stepNumber = action.payload;
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setStepNumber, setIsEdit } = pageSlice.actions;

export default pageSlice.reducer;
